import { KText } from '@/ui-library/components/text';
import { Box, Flex, Icon } from '@chakra-ui/react';
import { ChevronLeft } from '@kula-ai/icons/outline/ChevronLeft';

export const SecondaryFilter = ({
  filter = {},
  filterActions = () => {},
  activeFilter = {},
  clearSelected = () => {},
  setSelectedFilter = () => {},
}) => {
  const { component, modalActions, list, label } = filter;
  const FilterComponent = component;

  return (
    <Box>
      <Flex mb="12px" gap=".5em" alignItems="center">
        <Icon
          as={ChevronLeft}
          cursor="pointer"
          onClick={() => setSelectedFilter('')}
          color="primary-600"
        />
        <KText size="sm-semi-bold" flex="1" color="secondary-900">
          {label}
        </KText>
      </Flex>
      {component && (
        <FilterComponent
          filterConfig={filter}
          modalActions={modalActions}
          filterActions={filterActions}
          activeFilters={activeFilter}
          onAction={clearSelected}
          list={list || []}
          {...filter}
          type="secondary"
        />
      )}
    </Box>
  );
};
